import size from 'lodash.size';
import map from 'lodash.map';
import find from 'lodash.find';
import assign from 'lodash.assign';
import filter from 'lodash.filter';
import forEach from 'lodash.foreach';
import orderBy from 'lodash.orderby';
import cloneDeep from 'lodash.clonedeep';
import flattenDepth from 'lodash.flattendepth';
import { lSportsConfig } from '../config/lsports.config';

class Util {
    static assignBetSort = function (betObject, marketId) {
        let market = find(lSportsConfig.sort.bet, (i) => {
            return i.marketId === marketId;
        });

        let bet = null;

        if (market) {
            bet = find(market.bets, (i) => {
                return i.Name === betObject.Name;
            });
        }

        return bet
            ? assign(betObject, bet)
            : assign(betObject, {
                  Name: betObject.Name,
                  Sort: betObject.BaseLine ? betObject.BaseLine : betObject.Id,
              });
    };

    static sortBet = function (bets, marketId) {
        forEach(bets, (b, i) => {
            bets[i] = this.assignBetSort(b, marketId);
        });
        return orderBy(bets, ['Sort', 'Name'], 'dec');
    };

    static assignMarketSort = function (marketObject, sportId) {
        let sport = find(lSportsConfig.sort.market, (i) => {
            return i.sportId === sportId;
        });

        let market = null;

        if (sport) {
            market = find(sport.markets, (i) => {
                return i.Id === marketObject.Id;
            });
        }

        return market
            ? assign(marketObject, market)
            : assign(marketObject, {
                  Id: marketObject.Id,
                  Sort: marketObject.Id,
              });
    };

    static sortMarket = function (markets, sportId) {
        forEach(markets, (b, i) => {
            markets[i] = this.assignMarketSort(b, sportId);
        });
        return orderBy(markets, ['Sort'], 'dec');
    };

    static toFixedFloat = function (value, dec) {
        return parseFloat(parseFloat(value).toFixed(dec));
    };

    static prepareForRemoval = function (fixtures) {
        let fixturesClone = cloneDeep(fixtures);
        forEach(fixturesClone, (e) => {
            forEach(e.markets, (market) => {
                forEach(market.bets, (bet, key) => {
                    if (bet.Stake > 0.0 && bet.Status === 1) {
                        market.bets[key] = { ...bet, ...{ isPlaced: true } };
                    }
                });
            });
        });

        return fixturesClone;
    };

    static prepareAllForRemoval = function (fixtures) {
        let fixturesClone = cloneDeep(fixtures);
        forEach(fixturesClone, (e) => {
            forEach(e.markets, (market) => {
                forEach(market.bets, (bet, key) => {
                    market.bets[key] = { ...bet, ...{ isPlaced: true } };
                });
            });
        });

        return fixturesClone;
    };

    static filterBetStakeZeroOut = function (fixtures) {
        let fixturesClone = cloneDeep(fixtures);

        forEach(fixturesClone, (e) => {
            forEach(e.markets, (market) => {
                market.bets = filter(market.bets, (bet) => {
                    return bet.Stake > 0.0 && bet.Status === 1;
                });

                e.markets = filter(e.markets, (m) => {
                    return m.bets.length !== 0;
                });
            });

            fixturesClone = filter(fixturesClone, (g) => {
                return g.markets.length !== 0;
            });
        });

        return fixturesClone;
    };

    static filterBetStakeZeroIn = function (fixtures) {
        let fixturesClone = cloneDeep(fixtures);

        forEach(fixturesClone, (e) => {
            forEach(e.markets, (market) => {
                market.bets = filter(market.bets, (bet) => {
                    return bet.Stake <= 0.0 || bet.Status !== 1;
                });

                e.markets = filter(e.markets, (m) => {
                    return m.bets.length !== 0;
                });
            });

            fixturesClone = filter(fixturesClone, (g) => {
                return g.markets.length !== 0;
            });
        });

        return fixturesClone;
    };

    static convertToPlaceBetData = function (fixtures, type, multiStake = 0) {
        let data = map(fixtures, (fixture) => {
            return map(fixture.markets, (market) => {
                return map(market.bets, (bet) => {
                    return {
                        bet_id: bet.Id,
                        fixture_id: fixture.fixtureId,
                        market_id: market.Id,
                        provider_id: bet.provider,
                        champ: fixture.fixture.Fixture.Sport.Name + ',' + fixture.fixture.Fixture.Location.Name + ',' + fixture.fixture.Fixture.League.Name,
                        match: fixture.fixture.Fixture.Participants[0].Name + ' - ' + fixture.fixture.Fixture.Participants[1].Name,
                        market: market.market.Name,
                        name: bet.Name,
                        status: bet.Status,
                        price: bet.Price,
                        start_date: fixture.fixture.Fixture.StartDate,
                        stake: type === 1 ? bet.Stake : 0.0,
                        settlement: bet.Settlement,
                    };
                });
            });
        });

        return {
            bettype_id: type,
            multi_stake: multiStake,
            Bets: flattenDepth(data, 2),
        };
    };

    static placeBetValidation = function (fixtures, type, multiStake = 0) {
        let message = null;

        if (type === 2) {
            if (multiStake <= 0.0) {
                message = 'The multi stake must be greater than 0.';
                return message;
            }

            forEach(fixtures, (f) => {
                let canNotBeCombined = size(f.markets) > 1 || size(f.markets[0].bets) > 1;
                if (canNotBeCombined) {
                    message = 'Can not be combined.';
                    return message;
                }

                forEach(f.markets, (m) => {
                    forEach(m.bets, (b) => {
                        if (b.Status !== 1) {
                            message = b.Status === 2 ? 'The bet is suspended (bets cannot be placed)' : 'The bet is settled(bets cannot be placed)';
                            return message;
                        }
                    });
                });
            });
        } else if (type === 1) {
            // let count = 0;
            forEach(fixtures, (f) => {
                forEach(f.markets, (m) => {
                    forEach(m.bets, (b) => {
                        // count++;

                        if (b.Status !== 1) {
                            message = b.Status === 2 ? 'The bet is suspended (bets cannot be placed)' : 'The bet is settled(bets cannot be placed)';
                            return message;
                        }
                        if (b.Stake <= 0.0) {
                            message = 'The stake must be greater than 0.';
                            return message;
                        }
                    });
                });
            });
        }

        return message;
    };

    static placeBetValidationLimitsSingleBet = function (fixtures, betslip) {
        let message = null;

        let limits = betslip.limits;

        let maxStake = find(limits, { id: 1 });
        let minStake = find(limits, { id: 2 });
        let maxWin = find(limits, { id: 3 });
        // let minBetAmount = find(limits, { id: 6 });

        // let count = 0;
        forEach(fixtures, (f) => {
            forEach(f.markets, (m) => {
                forEach(m.bets, (b) => {
                    // count++;

                    if (b.Stake > maxStake.default_limit) {
                        message = 'The stake must be less than ' + maxStake.default_limit + '.';
                        return message;
                    }

                    if (b.Stake < minStake.default_limit) {
                        message = 'The stake must be greater than ' + minStake.default_limit + '.';
                        return message;
                    }
                });
            });
        });

        let totalFixtures = betslip.fixtures;
        let totalWin = 0.0;
        forEach(totalFixtures, (fixture) => {
            forEach(fixture.markets, (market) => {
                forEach(market.bets, (bet) => {
                    totalWin += parseFloat(bet.Stake) * parseFloat(bet.Price);
                });
            });
        });

        if (totalWin > maxWin.default_limit) {
            message = 'Max win amount is ' + maxWin.default_limit + '.';
            return message;
        }

        return message;
    };

    static placeBetValidationLimitsMultiBet = function (fixtures, betslip) {
        let message = null;

        let limits = betslip.limits;
        let totalMultiOdds = betslip.totalMultiOdds;
        let multiStake = betslip.multiStake;
        let totalWin = (parseFloat(multiStake) * parseFloat(totalMultiOdds)).toFixed(2);

        let maxOdd = find(limits, { id: 4 });
        let maxWin = find(limits, { id: 3 });
        let minStake = find(limits, { id: 9 });

        if (totalMultiOdds > maxOdd.default_limit) {
            message = 'Max odd is ' + maxOdd.default_limit + '.';
            return message;
        }

        if (totalWin > maxWin.default_limit) {
            message = 'Max win amount is ' + maxWin.default_limit + '.';
            return message;
        }

        if (multiStake < minStake.default_limit) {
            message = 'The stake must be greater than ' + minStake.default_limit + '.';
            return message;
        }

        return message;
    };
}

export default Util;
